import ReactGA from 'react-ga4';

const TRACKING_ID = 'G-6YXE0PZ13F';
const disabled = () => process.env.REACT_APP_DISABLE_ANALYTICS === 'true';

export const initGA = () => {
  if (disabled()) return;
  ReactGA.initialize(TRACKING_ID);
};

export const logPageView = () => {
  if (disabled()) return;
  ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
};

export const logEvent = (category = '', action = '', label = '') => {
  if (!disabled() && category) {
    ReactGA.event({ category, action, label });
  }
};

export const logException = (description = '', fatal = false) => {
  if (!disabled() && description) {
    ReactGA.event({
      category: 'Exception',
      action: description,
      label: fatal ? 'Fatal' : 'Non-fatal'
    });
  }
};
